import { Dialog } from "@headlessui/react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import React, { useState } from "react";
import LoginForm from '../LoginForm/LoginForm';

const LoginModal = ({ isOpen, setIsOpen }) => {
  const [modalTitle, setModalTitle] = useState("Войдите или создайте аккаунт");
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-10 focus:outline-none">
      <div className="fixed inset-0 bg-black/40 flex items-center justify-center" onClick={() => setIsOpen(false)}>
        {/* Анимация окна */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.3 }}
          className="bg-white shadow-lg p-6 rounded-lg w-full max-w-md relative"
          onClick={(e) => e.stopPropagation()} // Чтобы не закрывалось при клике внутри
        >
          {/* Заголовок и кнопка закрытия */}
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-bold">{modalTitle}</h2>
            <button onClick={() => setIsOpen(false)}>
              <X className="w-6 h-6 text-gray-600" />
            </button>
          </div>

          <LoginForm setIsOpen={setIsOpen} setModalTitle={setModalTitle} />
        </motion.div>
      </div>
    </Dialog>
  )
}


export default LoginModal;
